import * as React from 'react'

function SvgCircleAdd(props, svgRef) {
  return (
    <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M.667 14c0 7.36 5.974 13.334 13.334 13.334 7.36 0 13.333-5.974 13.333-13.334 0-7.36-5.973-13.333-13.333-13.333S.667 6.64.667 14zm13.334-6.666c.736 0 1.333.597 1.333 1.333v2a2 2 0 002 2h2a1.333 1.333 0 110 2.667h-2a2 2 0 00-2 2v2a1.333 1.333 0 01-2.666 0v-2a2 2 0 00-2-2h-2a1.333 1.333 0 010-2.667h2a2 2 0 002-2v-2c0-.736.596-1.333 1.333-1.333z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgCircleAdd)
export default ForwardRef
